var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStoreIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60173 5.50829C7.22385 5.9029 7 6.51328 7 7.30367V35.5716C7 36.3637 7.22385 36.9741 7.60173 37.3664L7.69865 37.4581L23.7947 21.6251V21.2519L7.69807 5.41541L7.60115 5.50829H7.60173Z",
    fill: "url(#paint0_linear_1011_14799)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1583 26.9062L23.7941 21.6251V21.2518L29.1595 15.973L29.2818 16.0399L35.6383 19.5932C37.4539 20.6074 37.4539 22.2678 35.6383 23.2843L29.2818 26.837L29.1583 26.9062V26.9062Z",
    fill: "url(#paint1_linear_1011_14799)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2818 26.837L23.7942 21.4388L7.60173 37.3687C8.2 37.9923 9.18942 38.0691 10.3017 37.4471L29.2818 26.837",
    fill: "url(#paint2_linear_1011_14799)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2818 16.0405L10.3017 5.42918C9.18942 4.80783 8.2 4.88456 7.60173 5.50821L23.7942 21.4387L29.2818 16.0399V16.0405Z",
    fill: "url(#paint3_linear_1011_14799)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M29.1595 26.7194L10.3023 37.2597C9.24653 37.8505 8.30499 37.8112 7.69923 37.2735L7.6023 37.3687L7.69923 37.4599C8.30499 37.9964 9.24653 38.0368 10.3023 37.4472L29.2824 26.8371L29.1607 26.7194H29.1595Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M7.60173 37.1818C7.22385 36.7878 7 36.1768 7 35.3864V35.5734C7 36.3655 7.22385 36.9764 7.60173 37.3687L7.69865 37.2735L7.60173 37.1812V37.1818Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M35.6383 23.0974L29.1595 26.7193L29.2818 26.8387L35.6383 23.2867C36.5458 22.779 36.9999 22.1097 36.9999 21.4405C36.9237 22.0445 36.4604 22.6382 35.6383 23.098V23.0974Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M10.3017 5.61678L35.6383 19.7802C36.4627 20.2394 36.9237 20.8331 36.9999 21.4388C36.9999 20.7696 36.5458 20.1009 35.6383 19.5927L10.3017 5.43044C8.48672 4.41564 7 5.25852 7 7.3037V7.49062C7 5.44486 8.48499 4.60256 10.3017 5.61678Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1011_14799",
    x1: 22.3668,
    y1: 7.00665,
    x2: -3.35661,
    y2: 13.9585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1011_14799",
    x1: 38.0022,
    y1: 21.4392,
    x2: 6.56421,
    y2: 21.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1011_14799",
    x1: 26.2995,
    y1: 24.3723,
    x2: 6.10094,
    y2: 58.9372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1011_14799",
    x1: 3.52392,
    y1: -3.90173,
    x2: 12.544,
    y2: 11.5333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreIcon);
export default __webpack_public_path__ + "static/media/play-store-icon.a16fbd8143351e5065b01bfd1ac3ac06.svg";
export { ForwardRef as ReactComponent };